import { getTitleEnumValue } from '@/functions';
import { IHasClassName } from '@/interfaces';
import { GenderEnum } from '@/lib/enum';
import { CountryEnum } from '@/enums';
import IconFlag from './IconFlag';
import { cn } from '@/lib/utils';

type TProps = IHasClassName &
{
  iconFlagProps?: IHasClassName;
  countryIso3?: CountryEnum;
  useSingleChar?: boolean;
  gender: GenderEnum;
}

const LabelGender = ({ gender, countryIso3, className, iconFlagProps, useSingleChar }: TProps) => (
  <div className='flex items-center space-x-1'>
    <IconFlag
      country={countryIso3}
      {...iconFlagProps} />
    <span className={cn(
      'text-sm font-semibold',
      gender === GenderEnum.MALE && 'text-blue-500',
      gender === GenderEnum.FEMALE && 'text-pink-500',
      className
    )}>
      {
        useSingleChar
          ? getTitleEnumValue('GenderEnum', gender)[0]
          : getTitleEnumValue('GenderEnum', gender)
      }
    </span>
  </div>
);

export default LabelGender;
